const routes = [
  {
    path: 'kpi-dashboard',
    name: 'kpiDashboard',
    component: () => import(/* webpackChunkName: "kpi-dashboard" */ './views/kpiDashboard.vue'),
    meta: {
      permissionRequired: false,
    },
  },
];

export default routes;
